export function shouldReopenJudgeSubmission(submitted, scoredRoundCount, totalRounds) {
  return submitted && scoredRoundCount < totalRounds;
}
